import { Badge, Button, Card, Col, Empty, Pagination, Row, Spin } from 'antd';
import dayjs from 'dayjs';
import { DocumentsApiService } from 'features/document-report/api/documents-api.service';
import FileViewer from 'features/new-clients/components/clients-details/file-viewer';
import { useUserContext } from 'features/users';
import { Info } from 'lucide-react'; // Import comments icon
import { Fragment, useEffect, useState } from 'react';
import { formatUtcToLocal } from 'routes/utils';

import { UploadAgainDocumentsModal } from './upload-again';

export const RejectedDocumentView = ({
  setAddCommentsModal,
  setCommentsInfo,
  getDocumentsCount,
  year,
  month,
  searchName,
  finishedValue,
  initilaMarkFinished,
  rejectdocument,
  handleClick,
}: any) => {
  const { user } = useUserContext();
  const [state, setState] = useState<any>(null);
  const [documentInfo, setDocumentsInfo] = useState<any>('');
  const [UploadModal, setUploadModal] = useState(false);
  const activetabValue: any = localStorage.getItem('activeTab');
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(9); // Number of items per page
  const [loading, setLoading] = useState(false);
  const [combinedData, setCombinedData] = useState<any[]>([]);

  const intialFetch = async () => {
    setLoading(true);
    try {
      const apiRes = await DocumentsApiService().getRejectedDocument({
        CompanyId: user?.CompanyId,
        PageIndex: currentPage,
        RecordPerPage: itemsPerPage,
        DocumentStatusId: 3,
        // PeriodId: selectedValue,
        Year: year,
        Month: month,
        Name: searchName,
        ClientId: user?.Id,
      });
      setState(apiRes);
    } catch (error) {
      console.error('Error fetching rejected documents:', error);
    } finally {
      setLoading(false);
    }
  };
  const handleFileViewerClick = (e: React.MouseEvent) => {
    e.stopPropagation(); // Prevents the card click from firing
  };
  useEffect(() => {
    const combineLists = () => {
      const documentCheckArray = Array.isArray(rejectdocument?.rc)
        ? rejectdocument?.rc
        : [];
      const pendingDocumentArray = Array.isArray(state?.rc) ? state.rc : [];
      // Combine and deduplicate lists based on documentId
      const combinedMap = new Map();
      documentCheckArray.forEach((doc: any) =>
        combinedMap.set(doc.documentId, doc),
      );
      pendingDocumentArray.forEach((doc: any) =>
        combinedMap.set(doc.documentId, doc),
      );
      setCombinedData(Array.from(combinedMap.values()));
    };
    combineLists();
  }, [rejectdocument, state]);
  useEffect(() => {
    if (activetabValue == 3) {
      intialFetch();
      // getDocumentsCount();
      initilaMarkFinished();
    }
  }, [year, month, activetabValue]);
  const handleCardClick = (item: any) => {
    setAddCommentsModal(true);
    setCommentsInfo(item);
  };
  const totalRecords = combinedData.length;
  const totalPages = Math.ceil(totalRecords / itemsPerPage);
  const paginatedData = combinedData.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage,
  );
  const handleUploadClick = (item: any, event: React.MouseEvent) => {
    event.stopPropagation(); // Prevent triggering the card click
    setUploadModal(true);
    setDocumentsInfo(item);
  };
  useEffect(() => {
    if (activetabValue == 3) {
      intialFetch();
      getDocumentsCount();
      initilaMarkFinished();
    }
  }, [year, month, activetabValue, currentPage, searchName]);

  return (
    <Fragment>
      {loading ? (
        <Col
          span={24}
          className='flex justify-center items-center'
          style={{ padding: '50px' }}
        >
          <Spin size='large' />
        </Col>
      ) : (
        <Row gutter={[16, 16]}>
          {paginatedData && paginatedData?.length > 0 ? (
            paginatedData.map((item: any, index: number) => (
              <Col
                key={item.id || index}
                span={6}
                xxl={6}
                xl={8}
                lg={10}
                md={12}
                sm={24}
                className='self-stretch'
              >
                <Card
                  onClick={() => handleCardClick(item)}
                  className='bg-[#F6F7F9] lgl_crd border-0 flex flex-col justify-between'
                  bodyStyle={{
                    padding: '16px',
                    display: 'flex',
                    flexDirection: 'column',
                    height: '100%',
                  }}
                >
                  <div className='flex gap-2'>
                    <div className='bg-white p-2 rounded-xl relative'>
                      {/* <div>
                        <FileText stroke='#8B91B1' strokeWidth={1} size={50} />
                      </div> */}
                      <figure
                        className='mediafolder'
                        onClick={handleFileViewerClick}
                      >
                        <FileViewer documentPath={item.documentPath} />
                      </figure>
                    </div>

                    <div className='flex flex-col grow'>
                      <div className='flex justify-between'>
                        <p className='font-bold'>{item?.documentName}</p>
                        <br />
                        {item?.documentStatus && (
                          <Badge className='bg-[#F5E1E9] border-[#F5C6CB] border border-solid text-[#F8516F] text-xs font-medium px-2.5 py-0.5 rounded leading-5 flex items-center rounded-xl'>
                            <Info size={15} className='mr-1' />
                            {item?.documentStatus}
                          </Badge>
                        )}
                      </div>
                      <p>{item?.categoryName}</p>
                      <p className='text-xs text-gray-500'>
                        Last Updated:{' '}
                        {/* {dayjs(item?.lastUpdatedDate).format('DD-MM-YYYY')} */}
                        {formatUtcToLocal(
                          dayjs(item?.lastUpdatedDate).format('DD-MMM-YYYY'),
                        )}
                      </p>
                    </div>
                  </div>
                  <div className='mt-4 flex justify-between items-center'>
                    <div className='flex  flex-col text-gray-600'>
                      <p className='text-red-500 font-semibold'>
                        Reasons for rejection
                      </p>
                      <p>{item?.reason}</p>
                      {/* <MessageCircle size={18} /> */}
                      {/* <span>{item?.commentsCount || 0} Comments</span> */}
                    </div>
                    {(!finishedValue?.rc ||
                      finishedValue?.rc.length === 0 ||
                      finishedValue?.rc[0]?.status === 1) && (
                      <Button
                        // type='primary'
                        onClick={(event) => handleUploadClick(item, event)}
                        className='bg-blue-900 text-white border-none text-xs btn-sm p-3 py-2 hover:bg-blue-950 hover:text-white rounded'
                      >
                        Upload Again
                      </Button>
                    )}
                  </div>
                </Card>
              </Col>
            ))
          ) : (
            <Col span={24}>
              <Empty description='No Rejected Documents Found' />
            </Col>
          )}
        </Row>
      )}
      {UploadModal && (
        <UploadAgainDocumentsModal
          onClose={() => setUploadModal(false)}
          documentInfo={documentInfo}
          intialFetch={intialFetch}
          year={year}
          month={month}
          // selectedValue={selectedValue}
          getDocumentsCount={getDocumentsCount}
          handleClick={handleClick}
        />
      )}
      {totalPages > 1 && (
        <Pagination
          current={currentPage}
          pageSize={itemsPerPage}
          total={totalRecords}
          onChange={(page) => setCurrentPage(page)}
          showSizeChanger={false} // Hides the page size dropdown
        />
      )}
    </Fragment>
  );
};
